import React, { useEffect } from "react";
import Footer from "./Footer";
import NavigationBar from "./navigation/NavigationBar";
import { useAuth, AuthContextState } from "../contexts/AuthContext";
import SidebarAdmin from "./sidebars/SidebarAdmin";
import SidebarClinician from "./sidebars/SidebarClinician";
import SidebarPatient from "./sidebars/SidebarPatient";

interface ContactProps {
  title: string;
}

const Contact = ({ title }: ContactProps) => {
  const { state: authState } = useAuth();
  const { userInfo } = authState as AuthContextState;

  useEffect(() => {
    document.title = title;
  }, [title]);

  return (
    <div className="header-fixed" id="body">
      {/* navigation bar (bar on the top) */}
      {authState.isAuthenticated ? <NavigationBar /> : null}
      <div className="container-fluid">
        <div className="row">
          {/* Sidebar (bar on the side) */}
          {authState.isAuthenticated ? (
            <>
              {userInfo?.userType === "patient" ? <SidebarPatient /> : null}
              {userInfo?.userType === "clinician" ? <SidebarClinician /> : null}
              {userInfo?.userType === "admin" ? <SidebarAdmin /> : null}
            </>
          ) : null}
          {/* Content */}
          <div className="col container p-3 " id="main-content">
            <h3>Kontakt</h3>
            {userInfo?.userType === "patient" ? (
              <div>
                <p>
                  Häufige Fragen werden{" "}
                  <a
                    href="https://sysdok.de/de/fuer-patientinnen/#FAQ"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    hier
                  </a>{" "}
                  beantwortet.
                </p>
                <p>
                  Bei weiteren technischen Fragen, kontaktieren Sie bitte zuerst
                  Ihre*n Therapeut*in. Sollte Ihr*e Therapeut*in nicht verfügbar
                  sein, kontaktieren Sie bitte Ihr Ambulanzsekretariat.
                </p>
              </div>
            ) : userInfo?.userType === "clinician" ? (
              <div>
                <p>
                  Bei technischen Fragen, kontaktieren Sie bitte Ihr
                  Ambulanzsekretariat, bzw. den*die SysDok-Administrator*in
                  Ihrer Ambulanz.
                </p>
                <p>
                  Häufige Fragen werden{" "}
                  <a
                    href="https://sysdok.de/de/fuer-therapeutinnen/#FAQ"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    hier
                  </a>{" "}
                  beantwortet.{" "}
                </p>
                <p>
                  Weitere inhaltliche Fragen zur SysDok Studie können Sie hier
                  stellen:{" "}
                </p>
                <p>
                  <a href="mailto:sysdok@uniklinik-freiburg.de">
                    sysdok@uniklinik-freiburg.de
                  </a>
                </p>
              </div>
            ) : (
              <div>
                <p>
                  {" "}
                  E-Mail:{" "}
                  <a href="mailto:sysdok@uniklinik-freiburg.de">
                    sysdok@uniklinik-freiburg.de
                  </a>
                </p>
                <p>Telefon: +49 761 270 68841</p>
              </div>
            )}
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Contact;
